import { render, staticRenderFns } from "./select-setting.component.vue?vue&type=template&id=4c658ed4&scoped=true"
import script from "./select-setting.component.vue?vue&type=script&lang=js"
export * from "./select-setting.component.vue?vue&type=script&lang=js"
import style0 from "./select-setting.component.vue?vue&type=style&index=0&id=4c658ed4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c658ed4",
  null
  
)

export default component.exports